<div class="layer-dialog">
    <div class="content markdown">
        <markdown #markdownElement [src]="layerFormatLink"></markdown>
    </div>
    <div class="close-button">
        <button mat-button mat-dialog-close>close</button>
    </div>
</div>
